import { render, staticRenderFns } from "./BaseWrapper.vue?vue&type=template&id=51064588&"
import script from "./BaseWrapper.vue?vue&type=script&lang=js&"
export * from "./BaseWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports